import React from 'react'

import { Box, DisplayPosition, ZIndex } from '@gousto-internal/citrus-react'

type FlexModalOverlayProps = {
  onClick?: () => void
}

export const FlexModalOverlay = ({ onClick }: FlexModalOverlayProps) => (
  <Box
    aria-hidden
    bottom="0"
    data-testid="flex-modal-overlay"
    left="0"
    onClick={onClick}
    onWheel={(event) => event.preventDefault()}
    position={DisplayPosition.Absolute}
    right="0"
    style={{ backgroundColor: 'rgba(51, 61, 71, 0.45)' }}
    top="0"
    zIndex={ZIndex.Top}
  />
)
